<template>
  <section class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">WHAT IS MINDFULNESS ?</span><br><span class="Head__main_jp">マインドフルネス 〜脳と心の休息法〜</span>
      </h2>
      <div class="Beginner__box_area">
        <div class="Beginner__box _dsp-none--pc _mg-b20">
          <img src="assets/img/ph_beginner01.jpg" alt="">
        </div>
        <div class="Beginner__box">
          <p class="_l-lg _mg-b20">
            マインドフルネスは脳と心の休息法です。<br>MELONでは、科学的エビデンスに基づいて、「ストレス解消」「睡眠の改善」などケースに合わせたプログラムをご提供します。
          </p>
          <p><a href="https://www.the-melon.com/blog/blog/mindfulness-6365" class="Link__line" target="_blank">記事「マインドフルネスとは?」</a></p>
        </div>
        <div class="Beginner__box _dsp-none--sp">
          <img src="assets/img/ph_beginner01.jpg" alt="">
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Mindfulness'
}
</script>
